import { render, staticRenderFns } from "./DesignPriorityForm.vue?vue&type=template&id=0b6cb408&"
import script from "./DesignPriorityForm.vue?vue&type=script&lang=js&"
export * from "./DesignPriorityForm.vue?vue&type=script&lang=js&"
import style0 from "./DesignPriorityForm.vue?vue&type=style&index=0&id=0b6cb408&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports